import { createFeatureSelector, createSelector } from '@ngrx/store'

import * as fromCheckout from './checkout'
import * as fromOrders from '../../orders/reducers'
import * as fromRoot from '../../reducers'

export { reducer } from './checkout'

export interface State extends fromRoot.State {
    checkout: fromCheckout.State
}

export const getCheckoutState =
    createFeatureSelector<fromCheckout.State>('checkout')

export const isCreating = createSelector(
    getCheckoutState,
    fromCheckout.isCreating
)

export const getError = createSelector(
    getCheckoutState,
    fromCheckout.getError
)

const getSummaryOrderNumber = createSelector(
    getCheckoutState,
    fromCheckout.getSummaryOrderNumber
)

export const getSummaryOrder = createSelector(
    fromOrders.getIndexedOrders,
    getSummaryOrderNumber,
    (orders, orderNumber) => orders[orderNumber]
)

export const getSummaryOrderExtraCosts = createSelector(
  getSummaryOrder,
  (order) => order && order.extraCosts
)

export const getDeliveryDates = createSelector(
  getCheckoutState,
  fromCheckout.getDeliveryDates,
)

export const getBackorderCounts = createSelector(
  getCheckoutState,
  fromCheckout.getBackorderCounts,
)
